import { Pipe, PipeTransform } from '@angular/core';
import { FundOrderTypesEnum, FundProductPricesEnum } from '@spa/api';
import { Helper } from '../classes';
import { LanguageService } from '../language.service';

@Pipe({
  name: 'orderType',
  pure: true
})
export class OrderTypePipe implements PipeTransform {
  constructor(private languageService: LanguageService) {
  }

  transform(value: FundOrderTypesEnum): string {
    const language = this.languageService.getCurrentLanguage();

    return Helper.textsHelper().getOrderTypeName(value, language);
  }
}
